export default __webpack_public_path__ + "static/media/loader.e61a886e.gif";